import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from '@/utils/cacheStore'
import '@/styles/index.scss'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import BaseTable from '@/components/base-table'

Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.component('BaseTable', BaseTable)
new Vue({
  router,
  store,
  render: (h) => h(App),
  created() {
    store.dispatch('permission/handleRoutes')
  }
}).$mount('#app')
